<template>
  <div v-show="!isServiceLoading">
    <div class="w-full pt-20">
      <div class="container mx-auto pl-20 pr-10">
        <div class="text-left text-sm text-gray-62 mt-10">
          <div class="flex">
            <span class="pt-1 mr-2"><img src="@/assets/icons/Back.svg" /></span>
            <router-link :to="{ name: 'Top' }"
              >サービス情報一覧へ戻る</router-link
            >
          </div>
        </div>
        <div>
          <div class="flex mb-16">
            <CompNav
              :categoryName="categoryName"
              :hasPublished="hasPublished"
              @show-modal="
                serviceDetail =
                  $event == 'preview' ? getPreviewData() : publicData;
                showModal = true;
              "
            ></CompNav>
            <div class="flex-1">
              <h2 class="text-2xl font-semibold text-gray-92 leading-8 mb-4">
                {{ categoryName }}
              </h2>
              <div class="text-gray-92">
                アンケート回答に関するご不明点はお気軽に画面右下のチャットボットよりお問い合わせください。担当者がサポートいたします。
              </div>
              <div class="mt-4">
                <div
                  class="icj-change-display-service"
                  style="margin-top: -48px; padding-top: 48px"
                >
                  <div
                    id="section1"
                    class="mb-8 py-12 pl-20 bg-white rounded-lg service_scroll_menu"
                    style="padding-right: 12.5rem"
                  >
                    <div class="flex items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        サービスの基本情報
                      </h3>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <template v-for="form in formDataService">
                        <div
                          :key="form.id"
                          :id="'target' + form.id"
                          :class="{
                            'col-span-2': !form.input_position,
                            'col-span-1': form.input_position,
                            'col-start-1': form.input_position == 'left',
                            'col-end-1': form.input_position == 'left',
                            'col-start-2': form.input_position == 'right',
                            'col-end-2': form.input_position == 'right',
                          }"
                          v-if="
                            notShows['.icj-change-display-service']
                              ? !notShows['.icj-change-display-service'][
                                  form.id
                                ]
                              : true
                          "
                          style="position: relative"
                        >
                          <CompFormParts
                            :inputData="inputDataService"
                            :form="form"
                            :publishRequestedExists="publishRequestedExists"
                            :isSubmit="isSubmit"
                          ></CompFormParts>
                        </div>
                      </template>
                    </div>
                    <div class="relative">
                      <div
                        class="errorDiv"
                        :class="{
                          'icj-required': true,
                          'icj-required-valid':
                            logoImageFile.url || logoImageFile.data,
                          'icj-error':
                            !logoImageFile.url && !logoImageFile.data,
                        }"
                        id="logoImageFile"
                      ></div>
                      <div
                        class="block p-5"
                        :class="{
                          'mb-5 bg-coral-light': errorMessages.logoImageFile,
                        }"
                      >
                        <div class="flex items-center font-semibold mb-3">
                          <h4 class="text-gray-92 text-sm">サービスロゴ画像</h4>
                          <span
                            class="ml-2"
                            style="color: #de2d2d; font-size: 11px"
                            >必須</span
                          >
                        </div>
                        <div>
                          <div>
                            <div
                              class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                            >
                              ファイル形式：<span class="font-light"
                                >jpg/png (500KB以下)</span
                              >
                            </div>
                          </div>
                          <div class="mt-2">
                            <div
                              class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                            >
                              推奨サイズ：<span class="font-light"
                                >横400px、縦288px以上</span
                              >
                            </div>
                          </div>
                          <div class="mt-4">
                            <label
                              for="service_upload_logo_image"
                              class="inline-block text-white text-sm rounded font-semibold px-10 py-3 mb-2 cursor-pointer text-center leading-none font-semibold"
                              :class="[
                                publishRequestedExists
                                  ? 'bg-gray-32'
                                  : 'bg-secondary-main',
                              ]"
                            >
                              画像をアップロード
                            </label>
                            <input
                              id="service_upload_logo_image"
                              type="file"
                              accept="image/*"
                              @change.prevent="selectedLogoImageFile($event)"
                              style="display: none"
                              :disabled="publishRequestedExists"
                            />
                            <div
                              v-if="errorMessages.logoImageFile"
                              class="text-danger text-sm"
                            >
                              {{ errorMessages.logoImageFile }}
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 relative">
                          <div
                            v-if="logoImageFile.data"
                            @mouseover="hoverShow = true"
                            @mouseleave="hoverShow = false"
                          >
                            <img
                              :src="logoImageFile.data"
                              width="200"
                              height="auto"
                              class="border"
                            />
                            <div
                              v-if="!publishRequestedExists"
                              v-show="hoverShow"
                              class="absolute"
                              style="top: -20px; left: 10px"
                            >
                              <button
                                class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                                style="
                                  box-shadow: 0px 0px 4px
                                    rgba(152, 163, 190, 0.6);
                                "
                                @click="
                                  (logoImageFile.data = ''),
                                    (logoImageFile.name = '')
                                "
                              >
                                <img src="@/assets/icons/Trash.svg" />
                              </button>
                            </div>
                          </div>
                          <div
                            v-else-if="logoImageFile.url"
                            style="width: 15rem"
                            @mouseover="hoverShow = true"
                            @mouseleave="hoverShow = false"
                          >
                            <img
                              :src="logoImageFile.url"
                              width="200"
                              height="auto"
                              class="border"
                            />
                            <div
                              v-if="!publishRequestedExists"
                              v-show="hoverShow"
                              class="absolute"
                              style="top: -20px; left: 10px"
                            >
                              <button
                                class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                                style="
                                  box-shadow: 0px 0px 4px
                                    rgba(152, 163, 190, 0.6);
                                "
                                @click="logoImageFile.url = ''"
                              >
                                <img src="@/assets/icons/Trash.svg" />
                              </button>
                            </div>
                          </div>
                          <div v-else>
                            <label
                              for="service_upload_logo_image"
                              class="bg-slate-50 flex justify-center cursor-pointer"
                              style="
                                width: 115px;
                                height: 83px;
                                border: 1px dashed #dde1ed;
                                box-sizing: border-box;
                              "
                            >
                              <input
                                id="service_upload_logo_image"
                                type="file"
                                accept="image/*"
                                @change.prevent="selectedLogoImageFile($event)"
                                style="display: none"
                                :disabled="publishRequestedExists"
                              />
                              <img
                                src="@/assets/icons/BackImage.svg"
                                style="width: 32px; height: auto"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="relative">
                      <div
                        class="errorDiv"
                        :class="{
                          'icj-required': true,
                          'icj-required-valid': inputDataImages.length > 0,
                          'icj-error': inputDataImages.length == 0,
                        }"
                        id="imageFile"
                      ></div>
                      <div
                        class="block p-5"
                        :class="{
                          'mb-5 bg-coral-light': errorMessages.imageFile,
                        }"
                      >
                        <div class="flex items-center font-semibold mb-3">
                          <h4 class="text-gray-92 text-sm">
                            サービスアイキャッチ画像
                          </h4>
                          <span
                            class="ml-2"
                            style="color: #de2d2d; font-size: 11px"
                            >必須</span
                          >
                        </div>
                        <div
                          class="text-sm leading-6 font-light mb-2 text-gray-92"
                        >
                          サービス内容が伝わる画像を5枚まで登録しましょう。<br />
                          横640px、縦460pxで表示されますが、<span
                            class="ic-text-red"
                            >2倍サイズ以上でのご登録を推奨</span
                          >しております。
                        </div>
                        <div>
                          <div
                            class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                          >
                            ファイル形式：<span class="font-light"
                              >jpg/png (1枚2MB以下)</span
                            >
                          </div>
                        </div>
                        <div class="mt-2">
                          <div
                            class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                          >
                            推奨サイズ：<span class="font-light"
                              >横1280px、縦920px以上</span
                            >
                          </div>
                        </div>
                        <div v-if="inputDataImages.length < 5" class="mt-4">
                          <div>
                            <label
                              for="service_upload_image"
                              class="inline-block text-white text-sm rounded font-semibold px-10 py-3 mb-2 cursor-pointer text-center leading-none font-semibold"
                              :class="[
                                publishRequestedExists
                                  ? 'bg-gray-32'
                                  : 'bg-secondary-main',
                              ]"
                            >
                              画像をアップロード
                            </label>
                            <input
                              id="service_upload_image"
                              name="service_upload_image"
                              type="file"
                              accept="image/*"
                              @change.prevent="selectedImageFile($event)"
                              style="display: none"
                              v-if="viewInputFile"
                              :disabled="publishRequestedExists"
                            />
                            <div
                              v-if="errorMessages.imageFile"
                              class="text-danger text-sm pb-2"
                            >
                              {{ errorMessages.imageFile }}
                            </div>
                          </div>
                        </div>

                        <div class="flex">
                          <draggable
                            v-model="inputDataImages"
                            class="flex mt-4"
                            item-key="id"
                            :sort="!publishRequestedExists"
                          >
                            <template
                              #item="{ element: inputDataImage, index }"
                            >
                              <div
                                class="mr-3 relative"
                                style="width: 115px"
                                @mouseover="mouseOverAction(index)"
                                @mouseleave="mouseLeaveAction(index)"
                              >
                                <img
                                  v-if="inputDataImage.data"
                                  :src="inputDataImage.data"
                                  width="160"
                                  height="auto"
                                  class="border"
                                />
                                <img
                                  v-else-if="inputDataImage.url"
                                  :src="inputDataImage.url"
                                  width="160"
                                  height="auto"
                                  class="border"
                                />
                                <div
                                  v-if="
                                    inputDataImages.length > 0 &&
                                    !publishRequestedExists
                                  "
                                  v-show="hoverShow && index === hoverIndex"
                                  class="absolute"
                                  style="top: -20px; right: 10px"
                                >
                                  <button
                                    class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                                    style="
                                      box-shadow: 0px 0px 4px
                                        rgba(152, 163, 190, 0.6);
                                    "
                                    @click="deleteInputDataImage(index)"
                                  >
                                    <img src="@/assets/icons/Trash.svg" />
                                  </button>
                                </div>
                              </div>
                            </template>
                          </draggable>
                          <div v-show="inputDataImages.length < 5" class="mt-4">
                            <label
                              for="service_upload_image"
                              class="bg-slate-50 flex justify-center cursor-pointer"
                              style="
                                width: 115px;
                                height: 83px;
                                border: 1px dashed #dde1ed;
                                box-sizing: border-box;
                              "
                            >
                              <input
                                id="service_upload_image"
                                name="service_upload_image"
                                type="file"
                                accept="image/*"
                                @change.prevent="selectedImageFile($event)"
                                style="display: none"
                                v-if="viewInputFile"
                                :disabled="publishRequestedExists"
                              />
                              <img
                                src="@/assets/icons/BackImage.svg"
                                style="width: 32px; height: auto"
                              />
                            </label>
                          </div>
                        </div>

                        <div
                          v-show="inputDataImages.length > 1"
                          class="text-gray-92 text-xs font-semibold mt-2"
                        >
                          ドラッグ&amp;ドロップで順番を入れ替えます。
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="icj-change-display-condition"
                  style="margin-top: -48px; padding-top: 48px"
                >
                  <div
                    id="section2"
                    class="mb-8 py-12 pl-20 bg-white rounded-lg service_scroll_menu"
                    style="padding-right: 12.5rem"
                  >
                    <div class="items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        サービスの特長とオプション
                      </h3>
                      <div
                        class="text-sm leading-6 font-light mb-6 text-gray-92"
                      >
                        サービスの特長と対応オプションを登録しましょう。内容がマッチング条件に反映されます。
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <template v-for="form in formDataCondition">
                        <div
                          :key="form.id"
                          :class="{
                            'col-span-2': !form.input_position,
                            'col-span-1': form.input_position,
                            'col-start-1': form.input_position == 'left',
                            'col-end-1': form.input_position == 'left',
                            'col-start-2': form.input_position == 'right',
                            'col-end-2': form.input_position == 'right',
                          }"
                          v-if="
                            notShows['.icj-change-display-condition']
                              ? !notShows['.icj-change-display-condition'][
                                  form.id
                                ]
                              : true
                          "
                          style="position: relative"
                        >
                          <CompFormParts
                            :inputData="inputDataCondition"
                            :form="form"
                            :publishRequestedExists="publishRequestedExists"
                            :isSubmit="isSubmit"
                          ></CompFormParts>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <div style="margin-top: -48px; padding-top: 48px">
                  <div
                    id="section3"
                    class="mb-8 py-12 pl-20 bg-white rounded-lg service_scroll_menu"
                    style="padding-right: 12.5rem"
                  >
                    <div class="items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        サービスの参考価格
                      </h3>
                      <div
                        class="text-sm leading-6 font-light mb-6 text-gray-92"
                      >
                        貴社サービスの最もベーシックなプラン名と相場を以下にご入力ください。
                      </div>
                    </div>
                    <div>
                      <div
                        v-for="(inputDataPrice, index) in inputDataPrices"
                        :key="'price_key' + index"
                        class="bg-slate-50 pt-6 pb-8 px-10 mb-6"
                        :class="['icj-change-display-price' + index]"
                      >
                        <div
                          v-if="inputDataPrices.length == index + 1"
                          id="last_price"
                        ></div>
                        <div class="text-right">
                          <button
                            class="text-sm bg-red-600 text-white rounded py-1 px-2 mt-2 font-semibold focus:outline-none"
                            @click="deleteInputDataPrice(index)"
                            :class="{ hidden: publishRequestedExists }"
                          >
                            参考価格を削除する
                          </button>
                        </div>
                        <h4
                          class="text-lg font-semibold text-gray-92"
                          style="margin-left: -20px"
                        >
                          【参考価格{{ index + 1 }}つ目】
                        </h4>
                        <div class="grid grid-cols-2 gap-4">
                          <template v-for="form in formDataPrice">
                            <div
                              :key="'price' + form.id"
                              :class="{
                                'col-span-2': !form.input_position,
                                'col-span-1': form.input_position,
                                'col-start-1': form.input_position == 'left',
                                'col-end-1': form.input_position == 'left',
                                'col-start-2': form.input_position == 'right',
                                'col-end-2': form.input_position == 'right',
                              }"
                              v-if="
                                notShows['.icj-change-display-price' + index]
                                  ? !notShows[
                                      '.icj-change-display-price' + index
                                    ][form.id]
                                  : true
                              "
                              style="position: relative"
                            >
                              <CompFormParts
                                :inputData="inputDataPrice"
                                :form="form"
                                :publishRequestedExists="publishRequestedExists"
                                :isSubmit="isSubmit"
                                :index="index"
                              ></CompFormParts>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="
                        inputDataPrices.length < maxCountPrices &&
                        !publishRequestedExists
                      "
                      class="text-right"
                    >
                      <button
                        class="ml-auto rounded-full py-2 pl-5 pr-6 text-gray-92 border text-sm focus:outline-none flex items-center"
                        @click="addInputDataPrice()"
                        v-scroll-to="{ el: '#last_price' }"
                        :disabled="publishRequestedExists"
                      >
                        <div class="mr-1">
                          <img
                            src="@/assets/icons/Plus.svg"
                            style="width: 12px; height: auto"
                          />
                        </div>
                        <div class="font-semibold">参考価格を追加</div>
                      </button>
                    </div>
                  </div>
                </div>

                <div style="margin-top: -48px; padding-top: 48px">
                  <div
                    id="section4"
                    class="mb-8 py-12 pl-20 bg-white rounded-lg service_scroll_menu"
                    style="padding-right: 12.5rem"
                  >
                    <div class="items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        サービスの導入実績
                      </h3>
                      <div
                        class="text-sm leading-6 font-light mb-4 text-gray-92"
                      >
                        貴社の実績を画像とテキストで紹介できます。<br />
                        ※複数登録を推奨。登録実績数が多いほうがカスタマーに指名される傾向があります。
                      </div>
                    </div>
                    <div
                      v-show="
                        inputDataCases.length < maxCountCases &&
                        !publishRequestedExists
                      "
                      class="text-right"
                    >
                      <button
                        class="border border-gray-38 rounded-lg my-4 py-2 text-gray-92 flex justify-center items-center min-w-full button-md"
                        @click="addInputDataCase('実績を追加_上')"
                        v-scroll-to="{ el: '#last_case' }"
                        :disabled="publishRequestedExists"
                      >
                        <div class="mr-3">
                          <img src="@/assets/icons/AddIcon.svg" />
                        </div>
                        <div>実績を追加</div>
                      </button>
                    </div>
                    <div
                      v-for="(inputDataCase, index) in inputDataCases"
                      :key="'case_key' + index"
                    >
                      <div
                        v-if="inputDataCases.length == index + 1"
                        id="last_case"
                      ></div>
                      <div
                        class="bg-slate-50 pt-6 pb-8 px-10 mb-4"
                        :class="['icj-change-display-case' + index]"
                      >
                        <div class="text-right">
                          <button
                            class="text-sm bg-red-600 text-white rounded py-1 px-2 mt-2 font-semibold focus:outline-none"
                            @click="deleteInputDataCase(index)"
                            :class="{ hidden: publishRequestedExists }"
                          >
                            実績を削除する
                          </button>
                        </div>
                        <h4
                          class="text-lg font-semibold text-gray-92"
                          style="margin-left: -20px"
                        >
                          【実績{{ index + 1 }}つ目】
                        </h4>
                        <div class="grid grid-cols-2 gap-4">
                          <template v-for="form in formDataCase">
                            <div
                              :key="'case' + form.id"
                              :class="{
                                'col-span-2': !form.input_position,
                                'col-span-1': form.input_position,
                                'col-start-1': form.input_position == 'left',
                                'col-end-1': form.input_position == 'left',
                                'col-start-2': form.input_position == 'right',
                                'col-end-2': form.input_position == 'right',
                              }"
                              v-if="
                                notShows['.icj-change-display-case' + index]
                                  ? !notShows[
                                      '.icj-change-display-case' + index
                                    ][form.id]
                                  : true
                              "
                              style="position: relative"
                            >
                              <CompFormParts
                                :inputData="inputDataCase"
                                :form="form"
                                :publishRequestedExists="publishRequestedExists"
                                :isSubmit="isSubmit"
                                :index="index"
                              ></CompFormParts>
                            </div>
                          </template>
                        </div>
                        <div v-if="serviceCaseImageExists">
                          <div class="relative">
                            <div
                              class="errorDiv"
                              :id="'caseImages' + index"
                            ></div>
                            <div
                              class="block p-5"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages.inputDataCases[index],
                              }"
                            >
                              <div
                                class="flex items-center flex-wrap font-semibold mb-3"
                              >
                                <div class="text-gray-92 text-sm leading-4">
                                  実績のイメージ画像
                                </div>
                              </div>
                              <div
                                class="text-sm leading-6 font-light mb-2 text-gray-92"
                              >
                                1枚登録できます。およそ横640px、縦460pxで表示されますが、<span
                                  class="ic-text-red"
                                  >2倍サイズ以上でのご登録を推奨</span
                                >しております。
                              </div>
                              <div>
                                <div
                                  class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                                >
                                  ファイル形式：<span class="font-light"
                                    >jpg/png (1枚2MB以下)</span
                                  >
                                </div>
                              </div>
                              <div class="mt-2">
                                <div
                                  class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 inline-block"
                                >
                                  推奨サイズ：<span class="font-light"
                                    >横1280px、縦920px以上</span
                                  >
                                </div>
                              </div>
                              <div class="mt-4">
                                <div>
                                  <label
                                    :for="
                                      'service_performance_upload_image' + index
                                    "
                                    class="inline-block text-white text-sm rounded font-semibold px-10 py-3 mb-2 cursor-pointer text-center leading-none font-semibold"
                                    :class="[
                                      publishRequestedExists
                                        ? 'bg-gray-32'
                                        : 'bg-secondary-main',
                                    ]"
                                  >
                                    画像をアップロード
                                  </label>
                                  <input
                                    :id="
                                      'service_performance_upload_image' + index
                                    "
                                    :name="
                                      'service_performance_upload_image' + index
                                    "
                                    type="file"
                                    accept="image/*"
                                    @change.prevent="
                                      selectedCaseImageFile($event, index)
                                    "
                                    style="display: none"
                                    :disabled="publishRequestedExists"
                                  />
                                  <div
                                    v-if="
                                      errorMessages.inputDataCases[index] ||
                                      false
                                    "
                                    class="text-danger text-sm"
                                  >
                                    {{ errorMessages.inputDataCases[index] }}
                                  </div>
                                </div>
                              </div>
                              <div class="mt-2 relative">
                                <div
                                  v-if="inputDataCase.image.data"
                                  class="mb-4 max-w-full"
                                  @mouseover="mouseOverAction(index)"
                                  @mouseleave="mouseLeaveAction(index)"
                                >
                                  <img
                                    :src="inputDataCase.image.data"
                                    width="560"
                                    height="auto"
                                  />
                                  <div
                                    v-if="!publishRequestedExists"
                                    v-show="hoverShow && index === hoverIndex"
                                    class="absolute"
                                    style="top: -20px; right: 10px"
                                  >
                                    <button
                                      class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                                      style="
                                        box-shadow: 0px 0px 4px
                                          rgba(152, 163, 190, 0.6);
                                      "
                                      @click="deleteInputDataCaseImage(index)"
                                    >
                                      <img src="@/assets/icons/Trash.svg" />
                                    </button>
                                  </div>
                                </div>
                                <div
                                  v-else-if="inputDataCase.image.url"
                                  class="mb-4 max-w-full"
                                  @mouseover="mouseOverAction(index)"
                                  @mouseleave="mouseLeaveAction(index)"
                                >
                                  <img
                                    :src="inputDataCase.image.url"
                                    width="560"
                                    height="auto"
                                  />
                                  <div
                                    v-if="!publishRequestedExists"
                                    v-show="hoverShow && index === hoverIndex"
                                    class="absolute"
                                    style="top: -20px; right: 10px"
                                  >
                                    <button
                                      class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                                      style="
                                        box-shadow: 0px 0px 4px
                                          rgba(152, 163, 190, 0.6);
                                      "
                                      @click="deleteInputDataCaseImage(index)"
                                    >
                                      <img src="@/assets/icons/Trash.svg" />
                                    </button>
                                  </div>
                                </div>
                                <div v-else>
                                  <label
                                    :for="
                                      'service_performance_upload_image' + index
                                    "
                                    class="bg-slate-50 flex justify-center cursor-pointer"
                                    style="
                                      width: 115px;
                                      height: 83px;
                                      border: 1px dashed #dde1ed;
                                      box-sizing: border-box;
                                    "
                                  >
                                    <input
                                      :id="
                                        'service_performance_upload_image' +
                                        index
                                      "
                                      :name="
                                        'service_performance_upload_image' +
                                        index
                                      "
                                      type="file"
                                      accept="image/*"
                                      @change.prevent="
                                        selectedCaseImageFile($event, index)
                                      "
                                      style="display: none"
                                      :disabled="publishRequestedExists"
                                    />
                                    <img
                                      src="@/assets/icons/BackImage.svg"
                                      style="width: 32px; height: auto"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="
                        inputDataCases.length < maxCountCases &&
                        !publishRequestedExists
                      "
                      class="text-right"
                    >
                      <button
                        class="border border-gray-38 rounded-lg py-2 text-gray-92 flex justify-center items-center min-w-full button-md"
                        @click="addInputDataCase('実績を追加_下')"
                        v-scroll-to="{ el: '#last_case' }"
                        :disabled="publishRequestedExists"
                      >
                        <div class="mr-3">
                          <img src="@/assets/icons/AddIcon.svg" />
                        </div>
                        <div>実績を追加</div>
                      </button>
                    </div>
                  </div>
                </div>

                <div style="margin-top: -48px; padding-top: 48px">
                  <div id="business">
                    <div
                      id="section5"
                      class="mb-8 py-12 pl-16 bg-white rounded service_scroll_menu"
                      style="padding-right: 12.5rem"
                    >
                      <div class="flex items-center ml-4">
                        <h3
                          class="text-xl font-semibold text-gray-92"
                          style="margin-bottom: 44px"
                        >
                          商談方法
                        </h3>
                      </div>
                      <div class="relative">
                        <div
                          class="errorDiv"
                          :class="{
                            'icj-required': true,
                            'icj-required-valid':
                              canOfflineMeeting || canOnlineMeeting,
                            'icj-error':
                              !canOfflineMeeting && !canOnlineMeeting,
                          }"
                          id="checkMeeting"
                        ></div>
                        <div
                          class="p-4"
                          :class="{
                            'bg-coral-light':
                              !canOfflineMeeting && !canOnlineMeeting,
                          }"
                        >
                          <div class="block mb-16">
                            <div class="text-gray-92 mb-6 font-semibold">
                              対応可能な商談方法をすべて選択してください<span
                                class="ml-2 text-coral-main"
                                style="font-size: 11px"
                                >必須</span
                              >
                            </div>
                            <div class="mt-1">
                              <label class="flex leading-4 body-md">
                                <input
                                  type="checkbox"
                                  class="form-checkbox"
                                  v-model="canOfflineMeeting"
                                  :disabled="publishRequestedExists"
                                  :class="[
                                    publishRequestedExists
                                      ? 'isDisabled'
                                      : 'isNotDisabled',
                                  ]"
                                />
                                <span class="ml-2 text-sm text-gray-92">
                                  対面商談
                                </span>
                              </label>
                              <div class="pl-5 text-gray-92 mb-4 mt-1 body-md">
                                お客様と対面で商談を行います。対応できる地域を選択できます。
                              </div>

                              <label class="flex leading-4 body-md">
                                <input
                                  type="checkbox"
                                  class="form-checkbox"
                                  v-model="canOnlineMeeting"
                                  :disabled="publishRequestedExists"
                                  :class="[
                                    publishRequestedExists
                                      ? 'isDisabled'
                                      : 'isNotDisabled',
                                  ]"
                                />
                                <div class="ml-2 text-sm text-gray-92">
                                  オンライン商談
                                </div>
                              </label>
                              <div class="pl-5 text-gray-92 mb-4 mt-1 body-md">
                                発注から納品までオンラインで完結する商談方法です。全国の顧客に対応となります。
                              </div>
                            </div>
                            <div
                              v-show="!canOfflineMeeting && !canOnlineMeeting"
                              class="text-danger mt-2"
                            >
                              1つ以上選択してください。
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="canOfflineMeeting" class="relative">
                        <div
                          class="errorDiv"
                          :class="{
                            'icj-required': true,
                            'icj-required-valid': meetingCityIds.length > 0,
                            'icj-error': meetingCityIds.length == 0,
                          }"
                          id="checkMeetingArea"
                        ></div>
                        <div
                          class="p-4"
                          :class="{
                            'bg-coral-light':
                              canOfflineMeeting && meetingCityIds.length == 0,
                          }"
                        >
                          <div class="block mb-6">
                            <span class="text-gray-92 font-semibold pt-2 mb-6">
                              対面で商談が可能な地域をすべて選択してください
                            </span>
                            <span
                              class="ml-2 text-coral-main font-semibold"
                              style="font-size: 11px"
                              >必須
                            </span>
                            <div
                              v-show="meetingCityIds.length == 0"
                              class="text-danger mt-2"
                            >
                              1つ以上選択してください。
                            </div>
                            <div
                              class="company_opportunity_tab border-b mb-4 mt-6"
                            >
                              <ul class="flex">
                                <li
                                  v-for="(area, index) in areas"
                                  :key="area.name"
                                  @click="tab = index"
                                  class="h-10 flex items-center justify-center text-gray-92 font-semibold cursor-pointer"
                                  :class="[tab == index ? 'active' : '']"
                                >
                                  {{ area.name }}
                                </li>
                              </ul>
                            </div>
                            <div>
                              <div
                                v-for="(area, index) in areas"
                                :key="'area' + area.name"
                              >
                                <template v-if="tab == index">
                                  <div
                                    v-for="pref in area.prefs"
                                    :key="'pref' + pref.id"
                                  >
                                    <div class="p-4 border-b border-gray-12">
                                      <div class="flex items-center">
                                        <div>
                                          <div
                                            class="flex text-gray-92 font-semibold"
                                          >
                                            <label
                                              class="flex leading-4 cursor-pointer"
                                            >
                                              <input
                                                type="checkbox"
                                                class="form-checkbox"
                                                :value="pref.id"
                                                v-model="cityChecks"
                                                @change="checkedPref(pref.id)"
                                                :disabled="
                                                  publishRequestedExists
                                                "
                                                :class="[
                                                  publishRequestedExists
                                                    ? 'isDisabled'
                                                    : 'isNotDisabled',
                                                ]"
                                              />
                                              <div
                                                class="ml-2 body-md"
                                                style="width: 8.75rem"
                                              >
                                                {{ pref.name }}
                                              </div>
                                            </label>
                                          </div>
                                        </div>
                                        <div
                                          class="relative"
                                          @mouseleave="
                                            selectorshow_constents = []
                                          "
                                        >
                                          <div
                                            class="border h-10 flex items-center justify-between rounded bg-white px-3 text-gray-92 cursor-pointer body-md"
                                            :class="{
                                              'bg-slate-50':
                                                countChecked[pref.id] == 0,
                                              'text-gray-92':
                                                selectorshow_constents[0] ==
                                                pref.id,
                                            }"
                                            style="min-width: 240px"
                                            :style="{
                                              border:
                                                selectorshow_constents[0] ==
                                                pref.id
                                                  ? '1px solid #2cb2b2'
                                                  : '',
                                            }"
                                            @click="selectorshowToggle(pref.id)"
                                          >
                                            <div
                                              v-if="
                                                countChecked[pref.id] > 0 &&
                                                !allChecks.includes(pref.id)
                                              "
                                            >
                                              {{
                                                countChecked[pref.id]
                                              }}件の市区町村
                                            </div>
                                            <div v-else>すべての市区町村</div>
                                            <img
                                              src="@/assets/icons/Select.svg"
                                              class="ml-2"
                                            />
                                          </div>
                                          <div
                                            v-show="
                                              selectorshow_constents.indexOf(
                                                pref.id
                                              ) >= 0
                                            "
                                            class="absolute right-0 py-2 bg-white rounded-lg flex flex-col z-10 overflow-y-scroll"
                                            style="
                                              box-shadow: 0px 0px 8px
                                                rgba(189, 189, 189, 0.5);
                                              min-width: 240px;
                                              max-height: 395px;
                                            "
                                          >
                                            <span
                                              class="text-right text-xs text-gray-62 cursor-pointer mb-2 body-md"
                                              style="padding-right: 1.125rem"
                                              @click="
                                                publishRequestedExists ||
                                                  checkedAll(pref.id, false)
                                              "
                                            >
                                              選択をすべて外す
                                            </span>
                                            <label
                                              class="flex items-center px-5 cursor-pointer text-gray-92 hover:bg-slate-100 body-md"
                                              style="min-height: 28px"
                                            >
                                              <input
                                                type="checkbox"
                                                :value="pref.id"
                                                v-model="allChecks"
                                                @change="checkedAll(pref.id)"
                                                :disabled="
                                                  publishRequestedExists
                                                "
                                                :class="[
                                                  publishRequestedExists
                                                    ? 'isDisabled'
                                                    : 'isNotDisabled',
                                                ]"
                                              />
                                              <span class="ml-3">
                                                すべての市区町村
                                              </span>
                                            </label>
                                            <label
                                              v-for="city in cities[pref.id]"
                                              :key="'city' + city.id"
                                              style="min-height: 28px"
                                              class="flex items-center px-5 cursor-pointer text-gray-92 hover:bg-slate-100 body-md"
                                            >
                                              <input
                                                type="checkbox"
                                                :value="city.id"
                                                v-model="meetingCityIds"
                                                @change="
                                                  setCountChecked(pref.id)
                                                "
                                                :disabled="
                                                  publishRequestedExists
                                                "
                                                :class="[
                                                  publishRequestedExists
                                                    ? 'isDisabled'
                                                    : 'isNotDisabled',
                                                ]"
                                              />
                                              <span class="ml-3">
                                                {{ city.name }}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white sticky bottom-0 border-t border-gray-12">
        <div class="container mx-auto relative">
          <div class="flex justify-between items-center">
            <div class="ml-24">
              <template v-if="requiredCount > 0">
                <span
                  v-if="requiredCount - requiredValidCount > 0"
                  class="mr-4 text-gray-92"
                >
                  <span class="text-sm">あと</span>
                  <span class="font-semibold text-4xl mx-1">{{
                    requiredCount - requiredValidCount
                  }}</span>
                  <span class="text-sm">件の必須項目が残っています</span>
                </span>
                <span
                  v-else-if="publishRequestedExists"
                  class="mr-4 text-gray-92"
                >
                  <span class="text-sm font-semibold"
                    >現在公開申請中のため、編集できません</span
                  >
                </span>
                <span v-else class="mr-4 text-gray-92">
                  <span class="text-sm font-semibold"
                    >必須項目はすべて入力されています</span
                  >
                </span>
              </template>
              <transition name="fade-in-out">
                <span
                  v-show="footerMessageFlag"
                  class="text-sm text-gray-92 font-semibold"
                  style="color: #de2d2d"
                  >一時保存しました</span
                >
              </transition>
            </div>
            <div class="flex justify-end relative">
              <button
                class="text-base font-semibold py-5 px-12 h-16 focus:outline-none"
                :class="{
                  'text-gray-92': !publishRequestedExists,
                  'text-gray-32': publishRequestedExists,
                  'cursor-not-allowed': publishRequestedExists,
                  'hover:button': !publishRequestedExists,
                }"
                :disabled="publishRequestedExists || isSaving"
                @click="isDraftedDisplay || update()"
              >
                下書きに保存
              </button>
              <button
                v-if="!hasPublished"
                class="text-white text-base font-semibold py-5 px-12 h-16 focus:outline-none"
                :class="{
                  'ic-bg-red': !publishRequestedExists,
                  'bg-gray-32': publishRequestedExists,
                  'hover:bg-blue-100': !publishRequestedExists,
                  'cursor-not-allowed': publishRequestedExists,
                  'hover:button': !publishRequestedExists,
                }"
                :disabled="publishRequestedExists || isSubmitted"
                @click="isDraftedDisplay || update('publish')"
              >
                この内容で公開申請
              </button>
              <button
                v-else
                class="ic-bg-red text-white text-base font-semibold py-5 px-12 h-16 hover:bg-blue-100 hover:button focus:outline-none"
                :disabled="isUpdating"
                @click="isDraftedDisplay || update('autoPublish')"
              >
                <svg
                  v-if="isUpdating"
                  class="motion-reduce:hidden animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  style="display: inline"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                内容を更新する
              </button>
            </div>
          </div>
        </div>
      </div>

      <ModalRight
        :showModal="showModal"
        :modalOpacity="modalOpacity"
        @close-modal="showModal = false"
      >
        <ServiceCompanyDetail
          viewMode="service"
          :serviceDetail="serviceDetail"
          @close-modal="showModal = false"
        />
      </ModalRight>
    </div>
  </div>
</template>

<script>
import { inject, nextTick, onMounted, reactive, toRefs, watch } from 'vue';
import { useRoute } from 'vue-router';
import axios from '@/utils/axiosAuth.js';
import utils from '@/utils/utils';
import changeDisplayed from '@/utils/change-displayed';
import areas from '@/utils/areas';
import CompNav from '@/views/service/vue/CompNav';
import CompFormParts from '@/views/service/vue/CompFormParts';
import ModalRight from '@/components/modalRight/modalRight.vue';
import ServiceCompanyDetail from '@/components/modalRight/service/ServiceCompanyDetail.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    CompNav,
    CompFormParts,
    ModalRight,
    ServiceCompanyDetail,
    draggable,
  },
  setup() {
    const globalMethods = inject('globalMethods');
    const globalStore = inject('globalStore');

    const route = useRoute();
    const { runDisplayed, notShows } = changeDisplayed();

    const state = reactive({
      isSaving: false, // 下書きに保存
      isSubmitted: false,

      isDraftedDisplay: 1,

      serviceId: null,

      valid: false,
      isSubmit: false,

      footerMessageFlag: false,
      publishRequestedExists: 0,
      serviceCaseImageExists: 0,

      // 企業名
      companyName: '',

      // カテゴリー名
      categoryName: '',

      // ロゴ画像表示
      isLogoImageDisplayed: 0,

      // カテゴリークラス名
      categoryClassName: '',

      // form構造データ
      formDataService: {},
      formDataPrice: {},
      formDataCondition: {},
      formDataCase: {},

      // 入力データ
      inputDataService: {},
      inputDataPrices: [], // 参考価格は複数
      inputDataCondition: {},
      inputDataCases: [], // 事例は複数
      inputDataImages: [], // 画像は複数

      // サービス用ロゴ画像ファイル
      logoImageFile: {
        name: '',
        data: '',
        url: '',
      },

      // 状態 drafted or published
      status: '',

      // 初期データ
      initInputDataPrice: {}, // 参考価格
      initInputDataCase: {}, // 事例

      // サービス画像用
      viewInputFile: true,

      // watch用 Timer
      timer: null,

      // 商談方法
      canOfflineMeeting: 0,
      canOnlineMeeting: 0,
      meetingCityIds: [],

      tab: 1, // エリアtab番号（デフォルト関東）
      areas: areas, // 都道府県
      cities: {}, // 市区町村
      allChecks: [], // すべての市区町村がチェックされている都道府県
      cityChecks: [], // 1つ以上の市区町村がチェックされている都道府県
      countChecked: {}, // city表示用

      selectorshow: '', // 商談方法
      selectorshow_constents: [], // 商談方法

      errorMessages: {
        logoImageFile: '',
        imageFile: '',
        inputDataCases: {},
      },

      requiredCount: 0,
      requiredValidCount: 0,

      showModal: false,
      modalOpacity: true,
      publicData: {},
      serviceDetail: {},

      hasPublished: false,

      hoverShow: false,
      hoverIndex: null,
      isUpdating: false,
      isServiceLoading: true,
    });

    // フォーム最大数
    const maxCountPrices = 2;
    const maxCountCases = 100;

    // --------------------------------------------------------
    //  selected, add, delete
    // --------------------------------------------------------
    const fileError = (name, index, message) => {
      if (index != null) {
        state[name][index].image = {
          name: '',
          data: '',
          url: '',
        };
        state.errorMessages[name][index] = message;
      } else {
        state[name] = {
          name: '',
          data: '',
          url: '',
        };
        state.errorMessages[name] = message;
      }
      countingRequired();
    };
    const selectedLogoImageFile = async (e = null) => {
      if (e === null) {
        if (!state.logoImageFile.data && !state.logoImageFile.url) {
          fileError('logoImageFile', null, '必須項目です');
        }
        return;
      }
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          if (files[0].type != 'image/jpeg' && files[0].type != 'image/png') {
            fileError('logoImageFile', null, 'ファイルタイプが間違っています');
          } else if (files[0].size > 500 * 1024) {
            fileError('logoImageFile', null, 'ファイル容量が間違っています');
          } else {
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
              if (image.naturalWidth < 480 || image.naturalHeight < 140) {
                fileError(
                  'logoImageFile',
                  null,
                  'ファイルサイズが間違っています'
                );
              } else {
                state.errorMessages.logoImageFile = '';
                state.logoImageFile = {
                  name: files[0].name,
                  data: reader.result,
                  url: '',
                };
              }
            };
          }
        };
      } else {
        fileError('logoImageFile', null, 'ファイルが間違っています');
      }
    };
    const selectedImageFile = async (e = null) => {
      if (e === null) {
        if (state.inputDataImages.length == 0) {
          state.errorMessages.imageFile = '必須項目です';
        }

        return;
      }
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          if (files[0].type != 'image/jpeg' && files[0].type != 'image/png') {
            state.errorMessages.imageFile = 'ファイルタイプが間違っています';
          } else if (files[0].size > 2 * 1024 * 1024) {
            state.errorMessages.imageFile = 'ファイル容量が間違っています';
          } else {
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
              if (image.naturalWidth < 640 || image.naturalHeight < 460) {
                state.errorMessages.imageFile =
                  'ファイルサイズが間違っています';
              } else {
                state.errorMessages.imageFile = '';
                state.inputDataImages.push({
                  id: null,
                  data: reader.result,
                  name: files[0].name,
                  url: '',
                });
                state.viewInputFile = false;
                nextTick(() => {
                  state.viewInputFile = true;
                });
              }
            };
          }
        };
      } else {
        state.errorMessages.imageFile = 'ファイルが間違っています';
      }
    };
    const selectedCaseImageFile = async (e = null, index = null) => {
      if (e === null) {
        return;
      }
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          if (files[0].type != 'image/jpeg' && files[0].type != 'image/png') {
            fileError(
              'inputDataCases',
              index,
              'ファイルタイプが間違っています'
            );
          } else if (files[0].size > 2 * 1024 * 1024) {
            fileError('inputDataCases', index, 'ファイル容量が間違っています');
          } else {
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
              if (image.naturalWidth < 640 || image.naturalHeight < 460) {
                fileError(
                  'inputDataCases',
                  index,
                  'ファイルサイズが間違っています'
                );
              } else {
                state.errorMessages.inputDataCases[index] = '';
                state.inputDataCases[index].image = {
                  name: files[0].name,
                  data: reader.result,
                  url: '',
                };
              }
            };
          }
        };
      } else {
        fileError('inputDataCases', index, 'ファイルが間違っています');
      }
    };

    const addInputDataPrice = () => {
      state.inputDataPrices.push({ ...state.initInputDataPrice, id: null });
    };
    const addInputDataCase = (title) => {
      window.dataLayer?.push({
        event: 'tracking_click',
        title: title,
        userId: globalStore.user.id,
      });
      state.inputDataCases.push({ ...state.initInputDataCase, id: null });
    };
    const deleteInputDataPrice = async (index) => {
      state.inputDataPrices.splice(index, 1);
    };
    const deleteInputDataCase = (index) => {
      state.inputDataCases.splice(index, 1);
    };
    const deleteInputDataCaseImage = (index) => {
      state.inputDataCases[index].image_is_deleted = true;
      state.inputDataCases[index].image.data = '';
      state.inputDataCases[index].image.url = '';
    };
    const deleteInputDataImage = (index) => {
      state.inputDataImages.splice(index, 1);
    };

    // --------------------------------------------------------
    //  update
    // --------------------------------------------------------
    const getService = () => {
      return utils.object2Array(state.inputDataService);
    };
    const getImages = () => {
      let images = [];
      state.inputDataImages.forEach((image) => {
        images.push({
          id: image.id,
          file: image.data
            ? {
                name: image.name,
                content: image.data,
              }
            : null,
        });
      });
      return images;
    };
    const getCondition = () => {
      return utils.object2Array(state.inputDataCondition);
    };
    const getPrices = () => {
      let prices = [];
      state.inputDataPrices.forEach((data) => {
        // itemsだけにする
        let dataItems = { ...data };
        delete dataItems.id;

        prices.push({
          id: data.id,
          items: utils.object2Array(dataItems),
        });
      });
      return prices;
    };
    const getCases = () => {
      let cases = [];
      state.inputDataCases.forEach((data) => {
        // itemsだけにする
        let dataItems = { ...data };
        delete dataItems.id;
        delete dataItems.image;

        cases.push({
          id: data.id,
          image_is_deleted: data.image_is_deleted ? true : null,
          image_file: data.image.data
            ? {
                name: data.image.name || '',
                content: data.image.data,
              }
            : null,
          items: utils.object2Array(dataItems),
        });
      });

      return cases;
    };
    const updateService = async () => {
      if (state.isSaving === true || state.isSubmitted === true) {
        return;
      }
      state.isSaving = true;
      // サービス情報
      const service = await getService();
      // サービス画像
      const images = await getImages();
      // サービス参考価格
      const prices = await getPrices();
      // サービス条件
      const condition = await getCondition();
      // サービス事例
      const cases = await getCases();

      // サービス情報更新（下書き）
      const data = {
        logo_image_file: state.logoImageFile.data
          ? {
              name: state.logoImageFile.name,
              content: state.logoImageFile.data,
            }
          : null,
        items: service,
        images: images,
        prices: prices,
        conditions: condition,
        cases: cases,
        can_offline_meeting: state.canOfflineMeeting,
        can_online_meeting: state.canOnlineMeeting,
        meeting_city_ids: state.meetingCityIds,
      };

      await axios.post(`/services/${state.serviceId}/update`, data);
      state.isSaving = false;
    };
    const publishService = async () => {
      await axios.post(`/services/${state.serviceId}/publish`);
    };
    const autoPublishService = async () => {
      await axios.post(`/services/${state.serviceId}/auto-publish`);
    };

    const update = async (action = '') => {
      if (!state.valid) {
        state.isSubmit = true;
        selectedLogoImageFile();
        selectedImageFile();
        for (let i = 0; i < state.inputDataCases.length; i++) {
          selectedCaseImageFile(null, i);
        }
        const firstErrorId = document.getElementsByClassName('icj-error')[0].id;
        onScrollTo(firstErrorId);
        return;
      }

      let message = '';
      state.isUpdating = true;
      try {
        // サービス情報更新（下書き）
        await updateService();
        if (action === 'publish') {
          state.isSubmitted = true;
          await publishService();
          message = '公開申請しました';
          if (state.timer) {
            clearTimeout(state.timer);
          }
          state.publishRequestedExists = 1;
        } else if (action === 'autoPublish') {
          // サービス情報初期化&再更新後に再度必要な情報を取得
          await Promise.all([
            autoPublishService(),
            init(),
            setCountCheckedAll(),
            countingRequired(),
          ]).then(() => getServiceDetail());
          message = 'サービス情報を更新しました';
          if (state.timer) {
            clearTimeout(state.timer);
          }
        } else {
          message = '保存しました';
        }
      } finally {
        state.isUpdating = false;
      }

      globalMethods.isToast(message, { timeout: 3000 });
    };

    // --------------------------------------------------------
    //  swiper用
    // --------------------------------------------------------
    const openModalForSwiper = () => {
      state.modalOpacity = false;
      state.showModal = true;
    };
    const closeModalForSwiper = () => {
      state.showModal = false;
      setTimeout(() => {
        state.modalOpacity = true;
      }, 1000);
    };

    // --------------------------------------------------------
    //  現在のサービス情報
    // --------------------------------------------------------
    const getServiceDetail = async () => {
      await axios
        .get(`/services/${state.serviceId}/published`)
        .then((response) => {
          state.publicData = response.data.data;
          state.publicData.dataType = 'public';
        })
        .catch((e) => {
          if (e.response.status == '404') {
            state.hasPublished = false;
          } else {
            globalMethods.updateModal(
              true,
              '通信エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          }
        })
        .finally(() => {
          closeModalForSwiper();
        });
    };

    // --------------------------------------------------------
    //  init
    // --------------------------------------------------------
    const updateTmpService = async () => {
      await updateService();
      if (state.timer) {
        clearTimeout(state.timer);
      }
      state.footerMessageFlag = true;
      setTimeout(() => {
        state.footerMessageFlag = false;
      }, 3000);
    };
    const init = async () => {
      //
      // serviceの取得
      //
      let service = null;
      await axios
        .get('/services/' + state.serviceId)
        .then((response) => {
          // 企業名
          state.companyName = response.data.data.company_name;

          // カテゴリー名
          state.categoryName = response.data.data.category_name;

          // ロゴ表示
          state.isLogoImageDisplayed =
            response.data.data.is_logo_image_displayed;

          // カテゴリークラス名
          state.categoryClassName = response.data.data.category_class_name;

          // 画像有無
          state.serviceCaseImageExists =
            response.data.data.service_case_image_exists;

          // form構成
          state.formDataService = response.data.data.items;
          state.formDataPrice = response.data.data.price_items;
          state.formDataCondition = response.data.data.conditions;
          state.formDataCase = response.data.data.case_items;

          // 初期のinputData (追加時に利用)
          state.formDataPrice.forEach((data) => {
            state.initInputDataPrice[data.id] =
              data.input_type == 'checkbox' ? [] : '';
          });
          state.formDataCase.forEach((data) => {
            state.initInputDataCase[data.id] =
              data.input_type == 'checkbox' ? [] : '';
          });
          state.initInputDataCase['image'] = {
            url: '',
            data: '',
          };

          state.publishRequestedExists =
            response.data.data.publish_requested_exists;

          if (response.data.data.drafted) {
            // 下書きデータ
            service = response.data.data.drafted;
            state.status = 'drafted';
          } else if (response.data.data.published) {
            // 公開データ
            service = response.data.data.published;
            state.status = 'published';
          }
          if (response.data.data.published) {
            state.hasPublished = true;
          } else {
            state.hasPublished = false;
          }

          if (service) {
            state.logoImageFile.url = service.logo_image_file;
            state.inputDataService = {
              ...utils.array2Object(state.formDataService),
              ...utils.array2Object(service.items),
            };
            state.inputDataCondition = {
              ...utils.array2Object(state.formDataCondition),
              ...utils.array2Object(service.conditions),
            };
            state.inputDataImages = [];
            service.images.forEach((image) => {
              state.inputDataImages.push({
                id: image.id,
                data: '',
                url: image.file,
              });
            });
            state.inputDataPrices = [];
            service.prices.forEach((data) => {
              state.inputDataPrices.push({
                ...utils.array2Object(data.items),
                ...{
                  id: data.id,
                },
              });
            });
            state.inputDataCases = [];
            service.cases.forEach((data) => {
              state.inputDataCases.push({
                ...utils.array2Object(data.items),
                ...{
                  image: {
                    url: data.image_file,
                    data: '',
                  },
                  id: data.id,
                },
              });
            });

            // 商談方法
            state.canOfflineMeeting = !!service.can_offline_meeting;
            state.canOnlineMeeting = !!service.can_online_meeting;
            state.meetingCityIds = service.meeting_city_ids;
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        })
        .finally(() => {
          state.isServiceLoading = false;
          if (route.hash.length > 0) {
            setTimeout(() => {
              onScrollTo(route.hash.slice(1));
            }, 300);
          }
        });

      //
      // tmpデータの取得
      // @Note: 下書き仕様が変更になったため、基本的に使わない機能だが、過去にJSON保存していたデータも存在するため、処理は必要。
      //
      if (!service) {
        // サービス
        await axios
          .get(`/services/${state.serviceId}/tmps`)
          .then((response) => {
            if (response.data.data[0]) {
              const tmpData = response.data.data[0];

              // @NOTE: Laravelが空オブジェクトを空配列にしてしまうため、
              //        また、すでに保存されているデータがあるため、その対応
              if (Array.isArray(tmpData.service)) {
                tmpData.service = utils.array2ObjectTmpData(tmpData.service);
              }
              if (Array.isArray(tmpData.condition)) {
                tmpData.condition = utils.array2ObjectTmpData(
                  tmpData.condition
                );
              }

              state.inputDataService = tmpData.service || {};
              state.inputDataPrices = tmpData.prices || [];
              state.inputDataCondition = tmpData.condition || {};
              state.inputDataCases = tmpData.cases || [];

              if (tmpData.logoImageFile) {
                state.logoImageFile = tmpData.logoImageFile;
              }
              if (tmpData.images) {
                state.inputDataImages = tmpData.images;
              }

              if (tmpData.can_offline_meeting) {
                state.canOfflineMeeting = tmpData.can_offline_meeting;
              }
              if (tmpData.can_online_meeting) {
                state.canOnlineMeeting = tmpData.can_online_meeting;
              }
              if (tmpData.meeting_city_ids) {
                state.meetingCityIds = tmpData.meeting_city_ids;
              }
            }
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      }

      //
      // 一時保存
      //
      if (
        !state.hasPublished &&
        !state.publishRequestedExists &&
        !state.isDraftedDisplay
      ) {
        watch(
          () => [
            state.inputDataService,
            state.inputDataPrices,
            state.inputDataCondition,
            state.inputDataCases,
            state.inputDataImages,
            state.logoImageFile,
            state.canOfflineMeeting,
            state.canOnlineMeeting,
            state.meetingCityIds,
          ],
          () => {
            if (state.timer) {
              clearTimeout(state.timer);
            }
            state.timer = setTimeout(updateTmpService, 5000);
          },
          {
            deep: true,
            lazy: true,
          }
        );
      }
    };

    // --------------------------------------------------------
    //  商談方法のcheck
    // --------------------------------------------------------
    const setCountChecked = (pref_id) => {
      state.countChecked[pref_id] = 0;
      state.cities[pref_id].forEach((city) => {
        if (state.meetingCityIds.some((n) => n === city.id)) {
          state.countChecked[pref_id]++;
          if (state.countChecked[pref_id] === state.cities[pref_id].length) {
            state.allChecks.push(pref_id);
          } else {
            state.allChecks = state.allChecks.filter((id) => {
              return id !== pref_id;
            });
          }
        }
      });
      // 1つ以上チェックされているか
      let index = state.cityChecks.indexOf(pref_id);
      if (state.countChecked[pref_id] && index === -1) {
        state.cityChecks.push(pref_id);
      } else if (!state.countChecked[pref_id] && index !== -1) {
        state.cityChecks.splice(index, 1);
      }
    };
    const setCountCheckedAll = () => {
      Object.keys(state.cities).forEach((pref_id) => {
        setCountChecked(pref_id);
      });
    };
    // 都道府県選択/解除
    const checkedPref = (pref_id) => {
      if (state.cityChecks.includes(pref_id)) {
        if (!state.allChecks.includes[pref_id]) {
          state.allChecks.push(pref_id);
        }
        state.cities[pref_id].forEach((city) => {
          if (!state.meetingCityIds.includes(city.id)) {
            state.meetingCityIds.push(city.id);
          }
        });
        state.countChecked[pref_id] = state.cities[pref_id].length;
      } else {
        let index = state.allChecks.indexOf[pref_id];
        if (index !== -1) {
          state.allChecks.splice(index, 1);
        }
        state.cities[pref_id].forEach((city) => {
          let index = state.meetingCityIds.indexOf(city.id);
          if (index !== -1) {
            state.meetingCityIds.splice(index, 1);
          }
        });
        state.countChecked[pref_id] = 0;
      }
    };
    // すべての市区町村選択/解除
    const checkedAll = (pref_id, bool = null) => {
      if (bool === false) {
        state.allChecks = state.allChecks.filter((id) => {
          return id !== pref_id;
        });
      }
      if (state.allChecks.some((n) => n === pref_id)) {
        state.cities[pref_id].forEach((city) => {
          state.meetingCityIds.push(city.id);
        });
      } else {
        state.cities[pref_id].forEach((city) => {
          state.meetingCityIds = state.meetingCityIds.filter((city_id) => {
            return city_id !== city.id;
          });
        });
      }
      setCountChecked(pref_id);
    };
    const selectorshowToggle = (data) => {
      if (state.selectorshow_constents.indexOf(data) >= 0) {
        state.selectorshow_constents = state.selectorshow_constents.filter(
          (n) => n !== data
        );
      } else {
        state.selectorshow_constents.push(data);
      }
    };

    // --------------------------------------------------------
    //  必須項目関連 & valid
    // --------------------------------------------------------
    const countingRequired = () => {
      //
      // 表示非表示の実行
      //
      runDisplayed(state.formDataService, '.icj-change-display-service');
      runDisplayed(state.formDataCondition, '.icj-change-display-condition');
      for (let i = 0; i < maxCountPrices; i++) {
        runDisplayed(state.formDataPrice, `.icj-change-display-price${i}`);
      }
      for (let i = 0; i < maxCountCases; i++) {
        runDisplayed(state.formDataCase, `.icj-change-display-case${i}`);
      }

      nextTick(() => {
        state.requiredCount =
          document.getElementsByClassName('icj-required').length;
        state.requiredValidCount =
          document.getElementsByClassName('icj-required-valid').length;
        state.valid = document.getElementsByClassName('icj-error').length
          ? false
          : true;
      });
    };
    watch(
      () => [
        state.inputDataService,
        state.inputDataPrices,
        state.inputDataCondition,
        state.inputDataCases,
        state.inputDataImages,
        state.logoImageFile,
        state.canOfflineMeeting,
        state.canOnlineMeeting,
        state.meetingCityIds,
      ],
      () => {
        countingRequired();
      },
      { deep: true }
    );

    // --------------------------------------------------------
    //  previewData
    // --------------------------------------------------------
    const getPreviewData = () => {
      let previewData = {
        dataType: 'preview',
        company_name: state.companyName,
        category_name: state.categoryName,
        is_logo_image_displayed: state.isLogoImageDisplayed,
        case_image_exists: state.serviceCaseImageExists,
        logo_image_file: state.logoImageFile.data || state.logoImageFile.url,
        category_class_name: state.categoryClassName,
        catchphrase: '',
        url: '',
        items: [],
        images: [],
        advantages: [],
        prices: [],
        features: [],
        options: [],
        cases: [],
      };

      for (let item of state.formDataService) {
        if (/^advantage.*/.test(item.identifier)) {
          previewData.advantages.push({
            value: state.inputDataService[item.id],
          });
        } else if (['catchphrase', 'url'].includes(item.identifier)) {
          previewData[item.identifier] = state.inputDataService[item.id];
        } else {
          if (state.inputDataService[item.id]) {
            previewData.items.push({
              name: item.name,
              input_type: item.input_type,
              unit: item.unit,
              display_format_type: item.data_type,
              values: [
                {
                  value: state.inputDataService[item.id],
                },
              ],
            });
          }
        }
      }

      for (let image of state.inputDataImages) {
        previewData.images.push({
          file: image.data || image.url,
        });
      }

      for (let key of Object.keys(state.inputDataPrices)) {
        let object = {};
        for (let item of state.formDataPrice) {
          if (item.identifier == 'price') {
            object.price = {
              value: state.inputDataPrices[key][item.id],
              unit: item.unit,
            };
          } else {
            object[item.identifier] = state.inputDataPrices[key][item.id];
          }
        }
        previewData.prices.push(object);
      }

      for (let item of state.formDataCondition) {
        if (state.inputDataCondition[item.id]) {
          if (item.info_display_type == 'tag') {
            let values = [];
            for (let option of item.options) {
              if (option.is_info_displayed) {
                if (state.inputDataCondition[item.id].indexOf(option.id) >= 0) {
                  values.push({
                    value: option.name,
                  });
                }
              }
            }
            previewData.features.push({
              name: item.name,
              values: values,
            });
          } else if (item.info_display_type == 'boolean') {
            let values = [];
            for (let option of item.options) {
              if (option.is_info_displayed) {
                if (item.input_type == 'checkbox') {
                  values.push({
                    value: option.name,
                    is_available:
                      state.inputDataCondition[item.id].indexOf(option.id) >= 0
                        ? 1
                        : 0,
                  });
                } else {
                  values.push({
                    value: option.name,
                    is_available:
                      state.inputDataCondition[item.id] == option.id ? 1 : 0,
                  });
                }
              }
            }
            previewData.options.push({
              name: item.name,
              values: values,
            });
          } else if (item.info_display_type == 'detail') {
            let value = '';
            if (item.options.length > 0) {
              for (let option of item.options) {
                if (item.input_type == 'checkbox') {
                  if (
                    state.inputDataCondition[item.id].indexOf(option.id) >= 0
                  ) {
                    value += value ? ' / ' + option.name : option.name;
                  }
                } else {
                  if (state.inputDataCondition[item.id] == option.id) {
                    value = option.name;
                  }
                }
              }
            } else {
              value = state.inputDataCondition[item.id];
            }
            previewData.items.push({
              name: item.name,
              input_type: item.input_type,
              unit: item.unit,
              display_format_type: item.data_type,
              values: [
                {
                  value: value,
                },
              ],
            });
          }
        }
      }

      for (let key of Object.keys(state.inputDataCases)) {
        let object = {
          image_file:
            state.inputDataCases[key].image.data ||
            state.inputDataCases[key].image.url,
        };
        for (let item of state.formDataCase) {
          if (item.identifier == 'price') {
            object.price = {
              value: state.inputDataCases[key][item.id],
              unit: item.unit,
            };
          } else {
            object[item.identifier] = state.inputDataCases[key][item.id];
          }
        }
        previewData.cases.push(object);
      }

      return previewData;
    };

    // --------------------------------------------------------
    //  onMounted
    // --------------------------------------------------------
    onMounted(async () => {
      await axios
        .get('/sellers')
        .then((response) => {
          state.isDraftedDisplay = response.data.data[0].is_drafted_display;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });

      state.serviceId = route.params.serviceId;

      openModalForSwiper();

      init().then(() => {
        //
        // 市区町村情報
        //
        axios
          .get('/cities')
          .then((response) => {
            state.cities = response.data.data;
            setCountCheckedAll();
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });

        //
        // 現在のサービス情報
        //
        if (state.hasPublished) {
          getServiceDetail();
        } else {
          closeModalForSwiper();
        }

        countingRequired();
      });
    });

    function onScrollTo(id) {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }

    const mouseOverAction = (index) => {
      state.hoverShow = true;
      state.hoverIndex = index;
    };
    const mouseLeaveAction = () => {
      state.hoverShow = false;
    };

    return {
      ...toRefs(state),
      selectedLogoImageFile,
      selectedImageFile,
      selectedCaseImageFile,
      addInputDataPrice,
      addInputDataCase,
      deleteInputDataPrice,
      deleteInputDataCase,
      deleteInputDataCaseImage,
      deleteInputDataImage,
      update,
      setCountChecked,
      checkedAll,
      checkedPref,
      selectorshowToggle,
      notShows,

      onScrollTo,
      getPreviewData,

      mouseOverAction,
      mouseLeaveAction,
      maxCountPrices,
      maxCountCases,
    };
  },
};
</script>
<style lang="scss" scoped>
.ic-text-red {
  color: #de2d2d;
}
.ic-bg-red {
  background: #de2d2d;
}
.ic-border-bottom-red {
  border-bottom: #de2d2d 1px solid;
}
.fade-in-out-enter-active {
  animation: fade-in-out 0.5s;
}
.fade-in-out-leave-active {
  animation: fade-in-out 0.5s reverse;
}
@keyframes fade-in-out {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.company {
  &_opportunity {
    &_selectbox {
      width: 240px;
      @apply border;

      &_output {
        align-items: center;
        position: absolute;
        width: 240px;
        max-height: 395px;
        overflow-y: auto;
        padding: 8px 0;
        background-color: #fff;
        z-index: 1;
        box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);

        &_list:hover {
          background-color: #f1f2f6;
          span {
            @apply text-gray-92;
          }
        }

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        }

        &::-webkit-scrollbar-thumb {
          background-color: #dde1ed;
          border-radius: 10px;
          box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);
        }
      }
    }

    &_tab .active {
      background-color: #f1f2f6;
      @apply text-gray-92 border-b-2 border-gray-92;
    }

    &_tab ul li {
      width: 105px;
      border-bottom: 2px solid transparent;
    }
  }
}
.overflow-y-scroll {
  &::-webkit-scrollbar-thumb {
    background-color: #dde1ed;
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);
  }
}
</style>

<style lang="scss" scoped>
.isNotDisabled {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:hover::before {
    @apply border border-gray-92;
    box-shadow: 0px 0px 0px 2px rgba(52, 68, 100, 0.1);
  }
  &:checked::before {
    background: #28395c;
    border: 1px solid #28395c;
  }
  &:checked::after {
    opacity: 1;
  }
}

.isDisabled {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:checked::before {
    background: #dde1ed;
    @apply border;
  }
  &:checked::after {
    opacity: 1;
  }
}

.errorDiv {
  position: absolute;
  top: -56px;
  left: 0;
}
</style>
